import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

@Component({
  selector: 'lin-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MaintenanceComponent {
  @Input() title: string
  @Input() description: string
  @Input() isFill: boolean
}
